import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalTitle } from 'react-bootstrap';
import { Formik } from 'formik';
import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import SubmitButton from 'Shared/form/SubmitButton';
import usePublishProtocolTemplateMutation from 'App/hooks/usePublishProtocolTemplateMutation';
import { useBuilderContext } from '../BuilderContext';

const propTypes = {};

const defaultProps = {};

function PublishTemplateModal() {
    const { itemToPublish, setItemToPublish } = useBuilderContext();
    const publishTemplate = usePublishProtocolTemplateMutation();

    if (itemToPublish) {
        return (
            <Modal backdrop="static" show>
                <Modal.Header>
                    <ModalTitle>Publish Protocol Template</ModalTitle>
                </Modal.Header>

                <ModalBody>Are you sure you wish to publish this template?</ModalBody>
                <ModalFooter>
                    <Formik
                        initialValues={{
                            confirm: true,
                        }}
                        isInitialValid
                        onSubmit={() => {
                            return publishTemplate.mutateAsync(itemToPublish.uuid).then(() => setItemToPublish(null));
                        }}
                    >
                        {({ handleSubmit }) => (
                            <form onSubmit={handleSubmit}>
                                <FormButtonGroup>
                                    <Button
                                        variant="outline-secondary"
                                        type="button"
                                        onClick={() => setItemToPublish(null)}
                                    >
                                        Cancel
                                    </Button>
                                    <SubmitButton ignoreDirty>Publish</SubmitButton>
                                </FormButtonGroup>
                            </form>
                        )}
                    </Formik>
                </ModalFooter>
            </Modal>
        );
    }

    return null;
}

PublishTemplateModal.propTypes = propTypes;
PublishTemplateModal.defaultProps = defaultProps;

export default PublishTemplateModal;
